import script from "./AppEducation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppEducation.vue?vue&type=script&setup=true&lang=js"

import "./AppEducation.vue?vue&type=style&index=0&id=8d863af6&lang=scss"

const __exports__ = script;

export default __exports__